// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/shuffle.js';

import { paths } from '../generated/shuffle';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('shuffle', Original, paths);
